import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const slideWrapper = styled.div`
  width: 100%;

  strong {
    font-size: 15px;
    font-weight: 400;
    color: ${themeGet('text.0', '#2C2C2C')};
  }
`;

export const CenterWrapper = styled.div`
  text-align : center;
  padding-bottom :5px;

  .filter-btn{
    background-color:${themeGet('primary.0', '#008489')};
    color : #ffffff;
    margin-right: 5px;
  }
  .initialise-btn{
    width:70%;
  }
`;

export const ComponentWrapper = styled.div`
  display: box;
  width: 100%;
  align-items: center;
  position: relative;

  .target {
    right: 10px;
    left: auto;

    @media (max-width: 480px) {
      right: 25px;
    }
  }

  .select-search {
    right: 10px;
    width: 250px;
    position: absolute;
  };

    @media (max-width: 480px) {
      right: 25px;
    }
  }

  .select{
    background: red;
  }


  .date_picker {
    margin-bottom: 0;
    .DateRangePicker {
      .DateRangePickerInput {
        margin-left: 27px;
        width: 100%;
        max-width: 85%;
        border-color: ${themeGet('border.3', '#E6E6E6')};
        @media (max-width: 480px) {
          max-width: 300px;
        }
        .DateInput__small {
          width: calc(50% - 6px);
          .DateInput_input__small {
            padding: 12px 10px 10px;
            font-weight: 400;
            font-size: smaller;
            color: ${themeGet('text.0', '#2C2C2C')};
          }
          &:last-child {
            .DateInput_input__small {
              text-align: right;
            }
          }
        }
      }
      .DateRangePicker_picker {
        left: 1px !important;
        position: relative;
        display: flex;

      }
    }
  }



  /* view with popup component style */
  .view_with__popup {
    max-width: 100%;
    position: relative;

    &::before {
      content: '';
      width: 1px;
      height: 20px;
      display: inline-block;
      position: absolute;
      top: calc(50% - 10px);
      right: auto;
      left: 0;
      z-index: 1;
      background-color: ${themeGet('border.3', '#E6E6E6')};

      @media (max-width: 991px) {
        top: 0;
        bottom: auto;
        height: 1px;
        width: calc(100% - 40px);
        left: 20px;
      }

      @media (max-width: 480px) {
        width: calc(100% - 30px);
        left: 15px;
      }
    }

    /* popu handler style */
    .popup_handler {
      width: calc(100% - 14px);
      margin-left: 14px;

      button.ant-btn {
        min-width: auto;
        width: 100%;
        height: 60px;
        border: 0;
        padding: 0 30px;
        border-radius: 0;
        box-shadow: none;
        font-weight: 400;
        font-size: 15px;
        color: ${themeGet('text.0', '#2C2C2C')};
        background-color: ${themeGet('color.2', '#F7F7F7')};

        @media (max-width: 991px) {
          text-align: left;
          padding: 0 25px 0 30px;
        }

        @media (max-width: 480px) {
          height: 47px;
          padding: 0 20px 0 25px;
        }

        &::after {
          display: none;
        }
      }
    }

    &.room_guest {
      .popup_handler {
        button.ant-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }

    &.active {
      .popup_container {
        margin-top: 0;
        padding: 22px;
        box-shadow: 0 15px 46px -10px rgba(26, 26, 29, 0.3);

        @media (max-width: 991px) {
          margin-top: 0;
        }

        @media (max-width: 480px) {
          min-width: auto;
        }
      }
    }
  }

  /* icon style */
  > svg {
    position: absolute;
    z-index: 1;
    top: auto;
    &.map-marker,
    &.calendar,
    &.user-friends {
      left: 15px;
      right: auto;
      fill: ${themeGet('primary.0', '#008489')};
    }

    &.calendar {
      @media (max-width: 480px) {
        width: 14px;
        height: 14px;
      }
    }

    &.user-friends {
      width: 17px;
      height: 17px;
      @media (max-width: 480px) {
        width: 16px;
        height: 16px;
      }
    }

    &.caret-down {
      right: 12px;
      left: auto;
      fill: ${themeGet('text.1', '#909090')};

      @media (max-width: 991px) {
        right: 20px;
      }

      @media (max-width: 991px) {
        right: 15px;
      }
    }
  }
`;

const CategorySearchWrapper = styled.div`
  display: flex;
  align-items: center;

  .view_with__popup {
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }

    .popup_handler {
      button,
      button.ant-btn {
        height: 38px;
        font-size: 15px;
        border-radius: 3px;
        color: ${themeGet('text.0', '#2C2C2C')};
        border: 1px solid ${themeGet('border.3', '#E6E6E6')};
        &:hover {
          background-color: ${themeGet('border.3', '#E6E6E6')};
        }
        &::after {
          content: none;
        }
      }
    }

    &.active {
      .popup_handler {
        button,
        button.ant-btn {
          color: ${themeGet('color.1', '#ffffff')};
          border-color: ${themeGet('primary.0', '#008489')};
          background-color: ${themeGet('primary.0', '#008489')};
        }

        & + .popup_container {
          margin-top: 15px;
          border: 1px solid ${themeGet('border.3', '#E6E6E6')};
        }
      }

      &::after {
        content: '';
        display: block;
        position: fixed;
        left: 0;
        top: 70px;
        background-color: rgba(255, 255, 255, 0.9);
        width: 100%;
        min-height: 100vh;
        pointer-events: none;
      }
    }

    &.activated {
      .popup_handler {
        button,
        button.ant-btn {
          color: ${themeGet('color.1', '#ffffff')};
          border-color: ${themeGet('primary.0', '#008489')};
          background-color: ${themeGet('primary.0', '#008489')};
          &:hover {
            opacity: 0.85;
          }
        }
      }
    }

    .popup_container {
      #popup {
        > div {
          > button,
          > .ant-btn {
            color: ${themeGet('text.0', '#2C2C2C')};
            font-size: 15px;
            height: 38px;
            border-radius: 3px;
            border: 1px solid ${themeGet('border.3', '#E6E6E6')};
            &::after {
              content: none;
            }
            &:hover {
              color: ${themeGet('primary.0', '#008489')};
              border-color: ${themeGet('primary.0', '#008489')};
            }
          }
        }
      }
    }
  }

  .date_picker {
    .DateRangePicker {
      display: block;
      width: 100%;
      .DateRangePickerInput {
        width: 100%;
        border-color: ${themeGet('border.3', '#E6E6E6')};
        .DateInput__small {
          width: 102px;
          .DateInput_input__small {
            padding: 12px 10px 10px;
            font-weight: 400;
            color: ${themeGet('text.0', '#2C2C2C')};
          }
        }
      }
    }
  }
`;

export const RoomGuestWrapper = styled.div`
  width: 80%;
  margin-left : 20px;

  .ant-slider-horizontal
    .ant-slider-with-marks {
    margin-left: 25px !important;
  }

  .slider_cls {
    margin-left: 10px;

    @media (max-width: 480px) {
      margin-left: 16px;
    }
  }
`;

export const PriceRangeLabel = styled.div`
  white-space: nowrap !important;
`;


export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .quantity {
    height: 30px;
    input {
      font-size: 15px;
    }
    button.btn svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const ActionWrapper = styled.div`
  overflow: hidden;
  margin-top: 27px;

  .ant-btn {
    border: 0;
    padding: 0;
    height: auto;
    box-shadow: none;
    font-weight: 600;
    border-radius: 0;
    text-shadow: none;
    color: ${themeGet('text.2', '#777777')};
    border-bottom: 1px solid transparent;
    &:hover {
      color: ${themeGet('text.1', '#909090')};
      border-bottom-color: ${themeGet('text.1', '#909090')};
    }
    &:focus {
      outline: none;
    }

    &.ant-btn-primary {
      float: right;
      border-color: transparent;
      background-color: transparent;
      color: ${themeGet('primary.0', '#008489')};
      &:hover {
        color: ${themeGet('primary.1', '#399C9F')};
        border-bottom-color: ${themeGet('primary.1', '#399C9F')};
      }
    }
    &::after {
      display: none;
    }
    &:not([disabled]):hover {
      text-decoration: underline;
    }
  }
`;

export const DateCategorieDayUseWrapper = styled.div`
  margin: 10px 10px 10px 26px;
  
`;

export default CategorySearchWrapper;
